import { IGetState, TBoardId, TFilterId } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { getSortedSavedFiltersIds } from '../selectors/getSortedSavedFiltersIds';
import { setSortedSavedFilterIds } from './setSortedSavedFilterIds';

export const removeFilterFromSortedSavedFilterIds = (
    boardId: TBoardId,
    filterId: TFilterId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const filterIds = getSortedSavedFiltersIds(state, boardId).filter(id => id !== filterId);
        dispatch(setSortedSavedFilterIds(boardId, filterIds));
    };
    return action;
};
